import React from "react";
import { FaRandom, FaLandmark, FaChartLine, FaNetworkWired, FaUsers } from "react-icons/fa";

function SelectedWork() {
  return (
    <>
      <div
        className="brand-style-two-area default-padding bg-theme text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-15.jpg)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Our Best Selling White Label Crypto Exchange Scripts
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="brand-style-two-items">
                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Binance</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaRandom size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Coinbase</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaLandmark size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>ByBit</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaChartLine size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>WazirX</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaNetworkWired size={48} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Paxful</h5>
                  <div className="info">
                    <div className="logo-icon d-flex align-items-center justify-content-center">
                      <FaUsers size={48} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SelectedWork;
